<!--
 * @Function: 创建试卷和编辑试卷
-->

<template>
  <div class="course-create-wrap">
    <a-form :form="form">
      <a-card :bordered="false" style="box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);">
        <div class="info-title">编辑考试</div>
        <div class="info-content" style="padding-top:25px;">
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试名称"
              >
                <a-input
                  placeholder="请输入考试名称"
                  v-decorator="[
                    'examName',
                    {rules: [{ required: true, message: '请输入考试名称' }]},
                  ]"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试类型"
              >
                <j-dict-select-tag
                  v-decorator="[
                    'examType',
                    {rules: [{ required: true, message: '请选择考试类型' }]},
                  ]"
                  placeholder="请选择考试类型"
                  dictCode="exam_test_type"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row>
          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="试卷类型"
              >
                <j-dict-select-tag
                  v-decorator="[
                    'paperType',
                    {rules: [{ required: true, message: '请选择试卷类型' }]},
                  ]"
                  placeholder="请选择试卷类型"
                  dictCode="paper_type"
                  :triggerChange="true"/>
              </a-form-item>
            </a-col>
          </a-row> -->
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试时间"
              >
               <a-range-picker style="width:100%" v-model="lastStudyTimeSt" @change="dateChange"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="考试说明"
              >
                <a-textarea v-decorator="['comment']" rows="4" placeholder="请输入正文" />
              </a-form-item>
            </a-col>
          </a-row>
          
          <!-- <a-row>
            <a-col :span="24">
              <a-form-item
                style="margin-bottom:12px;"
                :label-col="{ span: 2 }"
                :wrapper-col=" { span: 14 }"
                label="试卷难度"
              >
                <span>
                  <a-rate v-model="difficulty" :tooltips="difficultyName" />
                  <span class="ant-rate-text">{{ difficultyName[difficulty - 1] }}</span>
                </span>
              </a-form-item>
            </a-col>
          </a-row> -->
        </div>
      </a-card>
      
      <a-card
        :bordered="false"
        style="text-align:center;padding:14px 0px;box-shadow:0px 1px 10px 0px rgba(0,0,0,0.06);margin-top:20px;"
      >
        <div class="a-row">
          <a-button
            style="text-align:center;width:232px;line-height:40px;height:40px;font-size:14px;"
            type="primary"
            @click="examCreateOk()"
          >保存</a-button>
        </div>
      </a-card>
    </a-form>
    <select-topic-modal ref="selectTopicModal" @ok="okSelect"></select-topic-modal>
  </div>
</template>

<script>

  import Vue from 'vue'
  import { ACCESS_TOKEN, TENANT_ID } from '@/store/mutation-types'
  import { testAdd, testEdit, getTestById } from '@/api/api'
  import { initDictOptions } from '@/components/dict/JDictSelectUtil'
  import pick from 'lodash.pick'
  import _ from 'lodash'

  export default {
    name: 'TestModal',
    components: {
      
    },
    data() {
      return {
        // value: '',
        // type: '0',
        difficulty: 0,
        difficultyName: [],
        videoFullloading: false,
        isFrom: '',
        lastStudyTimeSt:"",
        limitStartTime:"",
        limitEndTime:"",
        form: this.$form.createForm(this),
        loading: false,
        // url: {
        //   fileUpload: window._CONFIG['domianURL'] + '/sys/common/upload'
        // },
        ipagination: false,
        dataSource: [
          // {
          //   tigan: '01',
          //   fenzhi: '5',
          //   zhishidian: '我就是知识点',
          //   chuzi: '202001卷'
          // }
        ],
        columns: [
          {
            title: '题序',
            align: 'center',
            dataIndex: 'sort',
            customRender: (text, row, index) => {
              return (<span >{index + 1}</span>)
            },
            width: 50
          },
          {
            title: '题干',
            align: 'center',
            dataIndex: 'stem',
            width: 200,
            customRender: (text, row) => {
              if(text.length>100){
                return text.substring(0,100)+"...";
              }
              return text;
            }
          },
          {
            title: '所属科目',
            align: 'center',
            dataIndex: 'subject_dictText',
            width: 100
          },
          {
            title: '题库目录',
            align: 'center',
            dataIndex: 'catalogId_dictText',
            width: 100
          },
          {
            title: '题型',
            align: 'center',
            dataIndex: 'type_dictText',
            width: 100
          },
          {
            title: '分值',
            align: 'center',
            dataIndex: 'score',
            width: 50
          },
          {
            title: '操作',
            dataIndex: 'action',
            align: 'center',
            scopedSlots: { customRender: 'action' },
            width: 260
          }
        ],
        paperItemList: [],
        selectExerciseIds: []
      }
    },

    methods: {

      dateChange:function(data,data1){
        console.log(data,data1)
        this.limitStartTime = data1[0];
        this.limitEndTime = data1[1];
      },
      
      examCreateOk() {
        this.form.validateFields((err, values) => {
          if (!err) {
            let id = this.id
            let valuesParam = {}
            valuesParam = { ...values }
            valuesParam.paperItemList = this.paperItemList
            valuesParam.difficulty = this.difficulty;

            // if (this.isFrom === 'addExercise') {
            //   valuesParam['chClass'] = 'e'
            // }
            let opFun = ''
            if (_.isEmpty(this.id)) {
              opFun = testAdd(valuesParam)
            } else {
              valuesParam = { ...valuesParam, id }
              opFun = testEdit(valuesParam)
            }

            // opFun.then((res) => {
            //   if (res.success) {
            //     this.$message.success(res.message, () => {
            //       this.$router.push({ path: '/exerciseManage/examList' })
            //     })
            //   } else {
            //     this.$message.warning(res.message)
            //   }
            // }).finally(() => {
            // })
          }
        })
      }
    },
    created () {

      this.id = this.$route.query.id

      if (!_.isEmpty(this.id)) {
        getTestById({ id: this.id }).then((res) => {
          if (res.success) {
            // console.log(res)
            let resultData = res.result

            this.$nextTick(() => {
              this.form.setFieldsValue(pick(resultData,'examName','examType', 'comment'))
            })
            this.lastStudyTimeSt = [moment(resultData.limitStartTime),moment(this.resultData.limitEndTime)];
            this.limitStartTime = resultData.limitStartTime;
            this.limitEndTime = resultData.limitEndTime;

            //this.paperItemList = this.resultData.paperItemList

            // this.videoFull = resultData.videoFull ? resultData.videoFull : { obsObjectUrl: '' }
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
        });
        
      }
    },
    computed: {
      uploadAction: function () {
        return this.url.fileUpload
      }
    }
  }
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
<style lang="scss" scoped >
.course-create-wrap {
  .info-title {
    border-bottom: 1px solid #e7ecef;
    line-height: 50px;
    height: 50px;
    padding-left: 25px;
  }

  .info-content {
    .img-tip {
      color: #999999;
      font-size: 12px;
    }
  }
  .item-options{
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    &:last-child{
      margin-bottom: 0px;
    }
    .item-name{
      padding-right: 10px;
    }
    .item-form{
      flex: 1;
    }
    .right-item{
      padding: 0px 6px;
      margin-left: 10px;
    }
    .item-remove{
      padding: 0px 6px;
      margin-right: 10px;
      cursor: pointer;
    }
  }
}
</style>
